<template>
    <div class="share">
        <div class="userInfo">
            <div class="avatar">
                <img :src="userInfo.avatar" alt="">
            </div>
            <h2>{{ userInfo.nickname }}</h2>
            <p>发布了方案锦囊</p>
        </div>
        <div id="download" class="download">
            打开APP查看>
        </div>
        <div class="logo"><img src="../../assets/img/common/logoFull.png" alt=""></div>
        <div v-if="isWeiXin" class="mark">
            <img src="../../assets/img/common/wxNotice.png" alt="">
        </div>
    </div>
</template>

<script>
import { importSdk } from "@/utils/tools";
import { isWeiXin, getQueryVariable } from "../../utils/base"
import { getLiveExpertInfo } from "../../api/other";
export default {
    name: 'share',
    data () {
        return {
            im_id: getQueryVariable('im_id'),
            isWeiXin: isWeiXin(),
            userInfo: null
        }
    },
    created () {
        this.initData()
    },
    mounted () {
        importSdk("https://web.cdn.openinstall.io/openinstall.js", this.initOpenInstall);
    },
    methods: {
        async initData () {
            const res = await getLiveExpertInfo({
                im_id: this.im_id
            })
            if (res.errno === 0) {
                this.userInfo = res.data
            } else {
                this.$toast(res.errmsg)
            }
        },
        initOpenInstall () {
            /* eslint-disable*/
            var data = OpenInstall.parseUrlParams();///openinstall.js中提供的工具函数，解析url中的所有查询参数
            new OpenInstall({
                /*appKey必选参数，OpenInstall平台为每个应用分配的ID*/
                appKey : process.env.VUE_APP_OPENINSTALLAPPKEY,
                onready : function() {
                    /*在app已安装的情况尝试拉起app*/
                    this.schemeWakeup();
                    /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                    var m = this;
                    var btn_1 = document.getElementById('download');
                    btn_1.style.visibility = "visible";
                    btn_1.onclick = function() {
                        m.wakeupOrInstall();
                        return false;
                    }
                }
            }, data);
        }
    }
}
</script>

<style lang="less" scoped>
.share{
    width: 100%;
    height: 100vh;
    background: url("../../assets/img/other/liveroomShareBg.png");
    background-size: cover;
    overflow: hidden;
    .userInfo{
        color: #fff;
        text-align: center;
        .avatar{
            width: 84px;
            height: 84px;
            border-radius: 50%;
            border: 2px solid #FFE1BE;
            margin: 130px auto 0 auto;
            overflow: hidden;
            img{
                width: 100%;
                object-fit: cover;
            }
        }
        h2{
            font-size: 24px;
            font-weight: 500;
            color: #fff;
            margin-top: 16px;
            line-height: 24px;
        }
        p{
            font-size: 16px;
            line-height: 19px;
            margin-top: 6px;
        }
    }
    .download{
        margin: 28px auto;
        width: 272px;
        height: 54px;
        line-height: 54px;
        background: linear-gradient( 90deg, #1B6AFF 0%, #178BFD 100%);
        box-shadow: 0px 2 6px 0px #218DFF;
        border-radius: 50px 50px 50px 50px;
        text-align: center;
        font-size: 18px;
        color: #fff;
    }
    .logo{
        width: 128px;
        position: fixed;
        bottom: 110px;
        left: calc(50% - 64px);
    }
    .mark{
        width: 100%;
        height: 100vh;
        position: absolute;
        background-color: rgba(0,0,0,0.4);
        top: 0;
        img{
            width: 132px;
            position: absolute;
            top: 13px;
            right: 27px;
        }
    }
}
</style>
